/**
 * Lead-submission helpers for the two public forms.
 *
 * Backend contract → POST /api/leads/submit
 *   { formType: "consultation" | "demo",
 *     name, email, message, phone?, course? }
 *
 * Both helpers throw on non-2xx so the caller can wire loading/error state
 * with a standard try/catch/finally.
 */
import { api } from "@/lib/api";

async function submitLead(payload) {
  try {
    const { data } = await api.post("/leads/submit", payload);
    return data;
  } catch (err) {
    const detail = err?.response?.data?.detail || err?.message || "Failed to send your request.";
    throw new Error(detail);
  }
}

/**
 * Consultation booking (Immigration / Study-Abroad enquiries).
 * Routes to ridkab.consultant@gmail.com.
 */
export function submitConsultation({ name, email, phone, course, message }) {
  return submitLead({
    formType: "consultation",
    name,
    email,
    phone,
    course,
    message,
  });
}

/**
 * Free-demo booking (Coaching enquiries).
 * Routes to languagenestindia@gmail.com.
 */
export function submitDemo({ name, email, phone, course, message }) {
  return submitLead({
    formType: "demo",
    name,
    email,
    phone,
    course,
    message,
  });
}
